import { render, staticRenderFns } from "./ContigencyBeneficary.vue?vue&type=template&id=322a86c6&scoped=true"
import script from "./ContigencyBeneficary.vue?vue&type=script&lang=js"
export * from "./ContigencyBeneficary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a86c6",
  null
  
)

export default component.exports